/* file description */
import React, { useState } from 'react';
import { Button, Calendar, DatePicker as MDatePicker, Popup, Space } from 'antd-mobile';
import type { DatePickerRef } from 'antd-mobile/es/components/date-picker';
import { useDebounceEffect } from 'ahooks';
import moment from 'moment';
import { MobileInput } from '../../component/MobileInput';

export const MobileDateTimePick = (props) => {
  const {
    isSystem,
    value,
    from,
    onlyTime,
    allowClear,
  } = props;

  useDebounceEffect(() => {
    if (isSystem && !value && from !== 'search') {
      props?.onChange(moment(new Date()));
    }
  }, [props], { wait: 500 });

  const [dateShow, setDateShow] = useState(false);
  return (
    <>
      <MobileInput
        value={props?.value ? moment(props?.value).format('YYYY-MM-DD') : undefined}
        onClick={() => setDateShow(true)}
        placeholder={props?.placeholder}
        disabled={props?.disabled}
      />
      <Popup
        visible={dateShow}
        onMaskClick={() => {
          setDateShow(false);
        }}
        bodyStyle={{ height: '70vh' }}
        destroyOnClose
      >
        <Calendar
          selectionMode="single"
          defaultValue={props?.value}
          onChange={(val) => {
            props?.onChange(moment(val));
            setDateShow(false);
          }}
        />
      </Popup>
    </>

  );
};
